var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.contactDialogVisible
        ? _c("contact-agent-dialog", {
            attrs: {
              "contact-dialog-visible": _vm.contactDialogVisible,
              "property-id": _vm.listingDetails.propertyId
            },
            on: {
              "update:contactDialogVisible": function($event) {
                _vm.contactDialogVisible = $event
              },
              "update:contact-dialog-visible": function($event) {
                _vm.contactDialogVisible = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "show-close": false,
            visible: _vm.shareDialogVisible,
            center: "",
            "custom-class": "share-dialog",
            title: "",
            width: "90%"
          },
          on: {
            "update:visible": function($event) {
              _vm.shareDialogVisible = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [
                  _c("div", { staticClass: "share-title" }, [
                    _vm._v("\n          Share this listing\n          "),
                    _c(
                      "div",
                      {
                        staticClass: "icon",
                        on: {
                          click: function($event) {
                            _vm.shareDialogVisible = !_vm.shareDialogVisible
                          }
                        }
                      },
                      [_c("i", { staticClass: "el-icon-close" })]
                    )
                  ])
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "share-list" }, [
            _c(
              "ul",
              _vm._l(_vm.shareList, function(item) {
                return _c(
                  "li",
                  {
                    key: item.class,
                    class: item.class,
                    on: {
                      click: function($event) {
                        return _vm.operate(item.id)
                      }
                    }
                  },
                  [
                    item.id == "email"
                      ? _c(
                          "a",
                          {
                            attrs: { href: _vm.emailContent, target: "_balnk" }
                          },
                          [_vm._v(_vm._s(item.title))]
                        )
                      : _c("span", [_vm._v(_vm._s(item.title))])
                  ]
                )
              }),
              0
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticStyle: { padding: "20px 0", "background-color": "#ffffff" } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    "margin-bottom": "10px",
                    display: "flex",
                    "align-items": "center",
                    padding: "0 5px"
                  }
                },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("span", { staticClass: "gray-chip" }, [
                      _vm._v(_vm._s(_vm.listingDetails.proertyType))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end"
                      },
                      attrs: { span: 12 }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "track",
                              rawName: "v-track:104.click",
                              value: _vm.shareAction,
                              expression: "shareAction",
                              arg: "104",
                              modifiers: { click: true }
                            }
                          ]
                        },
                        [
                          _c("el-image", {
                            staticClass: "share-button",
                            attrs: { src: require("../../assets/share-2.svg") },
                            on: {
                              click: function($event) {
                                _vm.shareDialogVisible = true
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "margin-bottom": "10px", padding: "0 5px" } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "address-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.listingDetails.address &&
                            _vm.listingDetails.suburb
                            ? _vm.listingDetails.address.trim() +
                                ", " +
                                _vm.listingDetails.suburb
                            : _vm.listingDetails.address ||
                              _vm.listingDetails.suburb
                            ? _vm.listingDetails.address ||
                              _vm.listingDetails.suburb
                            : "TBA"
                        )
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "margin-bottom": "10px", padding: "0 5px" } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("span", { staticClass: "state-text" }, [
                      _vm._v(
                        _vm._s(_vm.listingDetails.state) +
                          " " +
                          _vm._s(_vm.listingDetails.postcode)
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "margin-bottom": "10px", padding: "0 5px" } },
                [
                  _vm.listingDetails.price == 0 && _vm.listingDetails.price == 0
                    ? _c("el-col", { attrs: { span: 24 } }, [
                        _c("span", { staticClass: "div-22" }, [
                          _vm._v("Make an offer")
                        ])
                      ])
                    : _c("el-col", { attrs: { span: 24 } }, [
                        _c("span", { staticClass: "price-text" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.listingDetails.price != 0
                                  ? "$" + _vm.listingDetails.price
                                  : ""
                              ) +
                              "\n              " +
                              _vm._s(
                                _vm.listingDetails.maxPrice != 0
                                  ? " - $" + _vm.listingDetails.maxPrice
                                  : ""
                              ) +
                              "\n            "
                          )
                        ])
                      ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        "background-color": "#ffffff",
                        padding: "10px 0"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _vm.listingDetails.proertyType == _vm.apartment ||
                      _vm.listingDetails.proertyType == _vm.houseLand ||
                      _vm.listingDetails.proertyType == _vm.townhouse ||
                      _vm.listingDetails.proertyType == _vm.house
                        ? _c(
                            "el-row",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "align-items": "baseline"
                              },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-title",
                                  attrs: { span: 9 }
                                },
                                [_vm._v("Estimated Commencement")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-lbl",
                                  attrs: { span: 15 }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.listingDetails
                                          .estimatedCommenceMent == "" ||
                                          _vm.listingDetails
                                            .estimatedCommenceMent == null
                                          ? "TBA"
                                          : _vm.listingDetails
                                              .estimatedCommenceMent
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listingDetails.proertyType == _vm.apartment ||
                      _vm.listingDetails.proertyType == _vm.townhouse ||
                      _vm.listingDetails.proertyType == _vm.house ||
                      _vm.listingDetails.proertyType == _vm.houseLand
                        ? _c(
                            "el-row",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "align-items": "baseline"
                              },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-title",
                                  attrs: { span: 9 }
                                },
                                [_vm._v("Estimated Completion")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-lbl",
                                  attrs: { span: 15 }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.listingDetails
                                          .estimatedCompletion == "" ||
                                          _vm.listingDetails
                                            .estimatedCompletion == undefined ||
                                          _vm.listingDetails
                                            .estimatedCompletion == null
                                          ? "TBA"
                                          : _vm.listingDetails
                                              .estimatedCompletion
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listingDetails.proertyType == _vm.houseLand
                        ? _c(
                            "el-row",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "align-items": "baseline"
                              },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-title",
                                  attrs: { span: 9 }
                                },
                                [_vm._v("Land Price")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-lbl",
                                  attrs: { span: 15 }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayLandPrice(_vm.listingDetails)
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listingDetails.proertyType == _vm.houseLand
                        ? _c(
                            "el-row",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "align-items": "baseline"
                              },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-title",
                                  attrs: { span: 9 }
                                },
                                [_vm._v("Build Price")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-lbl",
                                  attrs: { span: 15 }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.displayBuildPrice(
                                          _vm.listingDetails
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listingDetails.proertyType == _vm.landOnly
                        ? _c(
                            "el-row",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "align-items": "baseline"
                              },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-title",
                                  attrs: { span: 9 }
                                },
                                [_vm._v("Land Size")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-lbl",
                                  attrs: { span: 15 }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getLandSizeValue(_vm.listingDetails)
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listingDetails.proertyType == _vm.landOnly
                        ? _c(
                            "el-row",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "align-items": "baseline"
                              },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-title",
                                  attrs: { span: 9 }
                                },
                                [_vm._v("Title Issued")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-lbl",
                                  attrs: { span: 15 }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.listingDetails.titlesIssued == 0 ||
                                          _vm.listingDetails.titlesIssued ==
                                            "" ||
                                          _vm.listingDetails.titlesIssued ==
                                            undefined ||
                                          _vm.listingDetails.titlesIssued ==
                                            null
                                          ? "TBA"
                                          : _vm.listingDetails.titlesIssued
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.listingDetails.proertyType == _vm.landOnly
                        ? _c(
                            "el-row",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                display: "flex",
                                "align-items": "baseline"
                              },
                              attrs: { gutter: 20 }
                            },
                            [
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-title",
                                  attrs: { span: 9 }
                                },
                                [_vm._v("Estimated Settled")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticClass: "desc-lbl",
                                  attrs: { span: 15 }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.listingDetails.estimatedSettled ==
                                          0 ||
                                          _vm.listingDetails.estimatedSettled ==
                                            "" ||
                                          _vm.listingDetails.estimatedSettled ==
                                            undefined ||
                                          _vm.listingDetails.estimatedSettled ==
                                            null
                                          ? "TBA"
                                          : _vm.listingDetails.estimatedSettled
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        {
                          staticStyle: {
                            "margin-bottom": "10px",
                            display: "flex",
                            "align-items": "baseline"
                          },
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            { staticClass: "desc-title", attrs: { span: 9 } },
                            [_vm._v("Contract Type")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { staticClass: "desc-lbl", attrs: { span: 15 } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.listingDetails.contractType == 0 ||
                                      _vm.listingDetails.contractType == null
                                      ? "TBA"
                                      : _vm.listingDetails.contractType
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "baseline"
                          },
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            { staticClass: "desc-title", attrs: { span: 9 } },
                            [_vm._v("Incentives")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { staticClass: "desc-lbl", attrs: { span: 15 } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.listingDetails.incentives == 0 ||
                                      _vm.listingDetails.incentives == null
                                      ? "TBA"
                                      : _vm.listingDetails.incentives
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { padding: "10px 5px 5px 5px" } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-contact-agent",
                          on: {
                            click: function($event) {
                              _vm.contactDialogVisible = true
                            }
                          }
                        },
                        [_vm._v("Enquire\n            ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { padding: "5px 5px 10px 5px" } },
                [
                  _c("el-col", {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column"
                    },
                    attrs: { span: 24 }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { padding: "10px 0" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-collapse",
                        {
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.activeNames,
                            callback: function($$v) {
                              _vm.activeNames = $$v
                            },
                            expression: "activeNames"
                          }
                        },
                        [
                          _c(
                            "el-collapse-item",
                            { attrs: { name: "1" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "font-style-collapse",
                                    staticStyle: { padding: "0 5px" }
                                  },
                                  [_vm._v("Description")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                {
                                  staticStyle: { padding: "10px" },
                                  attrs: { gutter: 20 }
                                },
                                [
                                  _c("el-col", { attrs: { span: 24 } }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "font-style-desc",
                                        staticStyle: {
                                          "white-space": "pre-wrap"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.listingDetails.description)
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-collapse-item",
                            { attrs: { name: "2" } },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "font-style-collapse",
                                    staticStyle: { padding: "0 5px" }
                                  },
                                  [_vm._v("Features")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                {
                                  staticStyle: { padding: "10px" },
                                  attrs: { gutter: 20 }
                                },
                                [
                                  _c("el-col", { attrs: { span: 24 } }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "font-style-desc",
                                        staticStyle: {
                                          "white-space": "pre-wrap"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.listingDetails.features)
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.listingDetails.brochure
                ? _c(
                    "el-row",
                    { staticStyle: { padding: "10px 5px" } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column"
                          },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-download",
                              on: { click: _vm.handleBrochureClick }
                            },
                            [_vm._v("Download Brochure")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-95f9f660", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95f9f660","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/propertyDetails/listingDetails.vue
// module id = null
// module chunks = 